// extracted by mini-css-extract-plugin
module.exports = {"containerFiltro":"FiltroPasta_containerFiltro__2CfD9","pasta":"FiltroPasta_pasta__2a2Cy"};